export const BASE = '/'
export const NOT_FOUND = 'not-found'

export const USERS = {
  BASE,
  CREATE: 'create',
  MY_PROFILE: 'my-profile',
  EDIT: 'edit/:groupId/:userId',
}
export const SETTINGS = {
  BASE,
  ADMIN_CONTENT: 'admin-content',
}
export const PROD_CONFIG = {
  BASE,
  SETTINGS: 'settings',
  get MODULES() {
    const modulesBase = 'modules'
    return {
      BASE: modulesBase,
      EDIT: `${modulesBase}/edit/:id`,
      CREATE: `${modulesBase}/create`,
    }
  },
  get GENERIC_MODULE_CONFIGURATION() {
    const genericConfigurationBase = 'generic-modules'
    return {
      BASE: genericConfigurationBase,
      MODULE: `${genericConfigurationBase}/:moduleName`,
    }
  },
}

export const CLIENT_CONFIG = {
  BASE,
  CONFIGURATION_ROUTE: (param: string) => {
    return {
      BASE: `${param}`,
      MODULE: `${param}/:moduleName`,
    }
  },
  get FEATURE_CONFIGURATION() {
    const featureConfigurationBase = 'feature-configuration'
    return {
      BASE: featureConfigurationBase,
      MODULE: `${featureConfigurationBase}/:moduleName`,
    }
  },
  get CLIENT_SETTINGS() {
    const clientSettingsBase = 'client-settings'
    return {
      BASE: clientSettingsBase,
      MODULE: `${clientSettingsBase}/:moduleName`,
    }
  },
}

export default {
  BASE,
  get LOGIN() {
    const loginBase = '/login'
    return {
      BASE: loginBase, // '/login'
      SSO: `${loginBase}/sso`, // '/login/sso',
      get MFA() {
        const mfaLoginBase = `${loginBase}/mfa`
        return {
          BASE: mfaLoginBase, // '/login/mfa'
          RECOVERY: `${mfaLoginBase}/recovery`, // 'login/mfa/recovery'
        }
      },
    }
  },
  get SETTINGS() {
    const settingsBase = '/settings'
    return {
      BASE: settingsBase,
      ADMIN_CONTENT: `${settingsBase}/admin-content`,
    }
  },
  get MFA() {
    const mfaBase = '/mfa'
    return {
      BASE: mfaBase, // '/mfa'
      DISABLE: `${mfaBase}/disable`, // '/mfa/disable'
      get SETUP() {
        const mfaSetupBase = `${mfaBase}/setup`
        return {
          BASE: mfaSetupBase, // 'mfa/setup'
          CODE: `${mfaSetupBase}/code`, // '/mfa/setup/code'
          BACKUP_CODES: `${mfaSetupBase}/backup-codes`, // 'mfa/setup/backup-codes'
        }
      },
      get EDIT() {
        const mfaEditBase = `${mfaBase}/edit`
        return {
          BASE: mfaEditBase, // '/mfa/edit'
          CODE: `${mfaEditBase}/code`, // '/mfa/edit/code'
          BACKUP_CODES: `${mfaEditBase}/backup-codes`, // '/mfa/edit/backup-codes
        }
      },
    }
  },
  get USERS() {
    const usersBase = '/users'
    return {
      BASE: usersBase, // '/users'
      CREATE: `${usersBase}/${USERS.CREATE}`, // '/users/create'
      MY_PROFILE: `${usersBase}/${USERS.MY_PROFILE}`, // '/users/my-profile'
      EDIT: `${usersBase}/${USERS.EDIT}`, // '/users/edit/:userId'
    }
  },
  DASHBOARD: '/dashboard',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  HELP: '/help',
  get PRODUCT() {
    const productBase = '/product'
    return {
      BASE: productBase, // 'product'
      MODULES: {
        BASE: `${productBase}/${PROD_CONFIG.MODULES.BASE}`,
        EDIT: `${productBase}/${PROD_CONFIG.MODULES.EDIT}`,
        CREATE: `${productBase}/${PROD_CONFIG.MODULES.CREATE}`,
      },
      GENERIC_MODULE_CONFIGURATION: {
        BASE: `${productBase}/${PROD_CONFIG.GENERIC_MODULE_CONFIGURATION.BASE}`,
        MODULE: `${productBase}/${PROD_CONFIG.GENERIC_MODULE_CONFIGURATION.MODULE}`,
      },
    }
  },
  get CLIENT() {
    const ClientBase = '/client'
    return {
      BASE: ClientBase, // '/client'
      FEATURE_CONFIGURATION: {
        BASE: `${ClientBase}/${CLIENT_CONFIG.FEATURE_CONFIGURATION.BASE}`,
        MODULE: `${ClientBase}/${CLIENT_CONFIG.FEATURE_CONFIGURATION.MODULE}`,
      },
      CONFIGURATION_ROUTE: (param: string) => {
        return {
          BASE: `${ClientBase}/${param}`,
          MODULE: `${ClientBase}/${param}/:moduleName`,
        }
      },
      CLIENT_SETTINGS: {
        BASE: `${ClientBase}/${CLIENT_CONFIG.CLIENT_SETTINGS.BASE}`,
        MODULE: `${ClientBase}/${CLIENT_CONFIG.CLIENT_SETTINGS.MODULE}`,
      },
    }
  },
  TERMS_OF_SERVICE: '/terms-services',
  PRIVACY_POLICY: '/privacy-policy',
  USER_ASSET: '/user-asset',
  UPDATE_PASSWORD: '/update-password',
  SSO: '/sso',
  NOT_FOUND: `/${NOT_FOUND}`,
  ERROR: '/error',
}
